import { authedDelete, authedGet, authedPost } from '../api/http';
import { semanticRequest } from './requestError';

type Reader<T> = (value: unknown) => T;

export const semanticGet = <T>(path: string, reader: Reader<T>): Promise<T> =>
  semanticRequest(() => authedGet<unknown>(path), reader);

export const semanticPost = <T>(path: string, body: unknown, reader: Reader<T>): Promise<T> =>
  semanticRequest(() => authedPost<unknown>(path, body), reader);

export const semanticDelete = (path: string): Promise<void> =>
  semanticRequest(() => authedDelete<unknown>(path), () => undefined);
